import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";
import type { IApiResponse } from "@/types";

export interface IYtdTotalRow {
  currencyCode: string | null;
  currencySymbol: string | null;
  gross: number;
  net: number;
  deductions: number;
  employerCost: number;
  statutoryEmployee: number;
  statutoryEmployer: number;
  employeeCount: number;
}

export interface IMonthRow {
  month: number;
  monthLabel: string;
  gross: number;
  net: number;
  deductions: number;
  employeeCount: number;
  currencyCode: string | null;
  byMethod: Record<string, number>;
}

export interface IBranchRow {
  branchId: number | null;
  branchName: string;
  gross: number;
  net: number;
  employeeCount: number;
  currencyCode: string | null;
}

export interface IDepartmentRow {
  departmentId: number | null;
  departmentName: string;
  gross: number;
  net: number;
  employeeCount: number;
  currencyCode: string | null;
}

export interface IPaymentMethodRow {
  method: string;
  label: string;
  net: number;
  employeeCount: number;
  currencyCode: string | null;
}

export interface IPayrollReportSummary {
  year: number;
  branchId: number | null;
  ytdTotals: IYtdTotalRow[];
  byMonth: IMonthRow[];
  byBranch: IBranchRow[];
  byDepartment: IDepartmentRow[];
  byPaymentMethod: IPaymentMethodRow[];
}

export interface IPayrollReportSummaryParams {
  year?: number;
  branchId?: number;
}

export const payrollReportsApi = createApi({
  reducerPath: "payrollReportsApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["payrollReportSummary"],
  endpoints: (builder) => ({
    getPayrollReportSummary: builder.query<
      IApiResponse<IPayrollReportSummary>,
      IPayrollReportSummaryParams | void
    >({
      query: (params) => ({
        url: "/company/payroll/reports/summary",
        method: "GET",
        params: {
          ...(params?.year ? { year: params.year } : {}),
          ...(params?.branchId ? { branchId: params.branchId } : {}),
        },
      }),
      providesTags: ["payrollReportSummary"],
    }),
  }),
});

export const { useGetPayrollReportSummaryQuery } = payrollReportsApi;
